import store from 'store2'

import post from '../../../lib/post'

export default function(o,email,lang,sendPasswordMail,done){

  var ombStore = store.namespace('omb')

  var newPassword = prompt('new password')

  if(!newPassword){
    return
  }

  var newPasswordRepeat = prompt('repeat new password')
  
  if(newPassword != newPasswordRepeat){
    alert('passwords do not match')
    return
  }

  var user = ombStore('email')
  var date = new Date()

  post(
    'auth',
    {
      token: ombStore('token'),
      type: 'reset',
      newPassword: newPassword,
      email: email,
      user: user,
      date: date,
      lang: lang,
      sendPasswordMail: sendPasswordMail,
    },
    function(error, result){
      if(error){
        done(error)
      } else {
        o.sounds.beep.play()
        o.feedback.ok('password reset')
        done()
      }
    }
  )

}



// WEBPACK FOOTER //
// ./src/client/view/admin/lib/authReset.js